import { render, staticRenderFns } from "./mapper.vue?vue&type=template&id=cf682568&scoped=true"
import script from "./mapper.vue?vue&type=script&lang=js"
export * from "./mapper.vue?vue&type=script&lang=js"
import style0 from "./mapper.vue?vue&type=style&index=0&id=cf682568&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf682568",
  null
  
)

export default component.exports